module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_FR.a0017b96.txt";